var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDownloadIconPermission(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 39,
    height: 39,
    rx: 5.5,
    stroke: "#FF7148"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.333 22.6703V25.7437C13.333 26.2095 13.5086 26.6562 13.8212 26.9856C14.1337 27.315 14.5576 27.5 14.9997 27.5H24.9997C25.4417 27.5 25.8656 27.315 26.1782 26.9856C26.4907 26.6562 26.6663 26.2095 26.6663 25.7437V22.6703M20.0005 12.5L20.0005 22.4521M20.0005 22.4521L16.1909 18.6494M20.0005 22.4521L23.81 18.6494",
    stroke: "#FF7148",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownloadIconPermission);
export default __webpack_public_path__ + "static/media/downloadIconPermission.14ed9bae94afde0d8586de1af81987be.svg";
export { ForwardRef as ReactComponent };